import axios from 'axios'
import { ref } from 'vue'

export function useDefaultMessages({
    onDeleted = () => {},
    onError = () => {},
}) {
    const deleting = ref(false)

    const deleteDefaultMessage = async (id) => {
        try {
            deleting.value = true
            await axios.delete(`/api/default-messages/${id}`)
            onDeleted()
        } catch (error) {
            onError(error)
        } finally {
            deleting.value = false
        }
    }

    return {
        deleting,
        deleteDefaultMessage,
    }
}
